<template>
    <el-dialog v-dialogDrag :visible.sync="showList" :title="title" width="460px" class="fast-link-device-list">
        <div v-for="device in deviceList" :Key="device.thirdAlarmDevId" class="clearfix">
            <div class="device-name fl">{{device.deviceName}}</div>
            <div @click="playVideo(device)" class="security icon-bofang2 play-btn fl"></div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props:[
        'deviceList'
    ],
    data(){
        return{
            showList:false,
            title:'',
            type:''
        }
    },
    methods:{
        open(type){
            this.showList = true;
            this.title = type == 'live'?this.$t('realTimeAlarm.label.realTimeVideo') : this.$t('realTimeAlarm.label.historyVideo');
            this.type = type;
        },
        playVideo(item){
            this.$emit('playVideo',this.type,item);
        }
    }
}
</script>

<style lang="scss">
    .fast-link-device-list{
        .el-dialog__body{
            padding-top: 0;
        }
        line-height: 30px;
        .device-name{
            width: 80%;
        }
        .play-btn{
            width: 10%;
            color: #0086ff;
            cursor: pointer;
        }
    }
</style>

